import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { apiClient, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPasswordPage() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [token, setToken] = useState("");
    const [password, setPassword] = useState("");

    useEffect(() => {
        const t = params.get("token");
        if (t) setToken(t);
    }, [params]);

    const submit = async (e) => {
        e.preventDefault();
        try {
            await apiClient.post("/auth/reset-password", { token, new_password: password });
            toast.success("Password updated. Please sign in.");
            navigate("/admin/login");
        } catch (err) {
            toast.error(formatApiError(err));
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-cream p-8">
            <form onSubmit={submit} className="w-full max-w-md" data-testid="reset-form">
                <div className="text-xs uppercase tracking-[0.25em] text-walnut-light mb-3">Reset</div>
                <h2 className="font-serif text-4xl text-ink">Set a new password</h2>

                <label className="block mt-8">
                    <span className="text-xs uppercase tracking-widest text-stone-muted block mb-2">Reset token</span>
                    <input data-testid="reset-token-input" required value={token} onChange={(e) => setToken(e.target.value)} className="w-full bg-white border border-stone-border px-4 py-3 focus:outline-none focus:border-walnut" />
                </label>
                <label className="block mt-5">
                    <span className="text-xs uppercase tracking-widest text-stone-muted block mb-2">New password (min 8 chars)</span>
                    <input data-testid="reset-password-input" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-white border border-stone-border px-4 py-3 focus:outline-none focus:border-walnut" />
                </label>
                <button data-testid="reset-submit" className="mt-6 w-full bg-walnut text-cream py-3 text-sm tracking-wider uppercase hover:bg-walnut-dark">Update password</button>

                <div className="mt-6 text-xs">
                    <Link to="/admin/login" className="text-stone-muted hover:text-walnut">← Back to sign in</Link>
                </div>
            </form>
        </div>
    );
}
